<template>
     <lx-dialog
      :is-visible-dialog.sync="isVisiable"
      :width="'80vw'"
      is-custome-footer
      class="lx-select-goods"
      @close="handleClose"
    >
      <div slot="title" class="title-dialog">
          <el-row>
              <el-col :span="12">
                  选择商品
              </el-col>
              <el-col :span="12">
                  <!-- 已选中{{ curSelectList.length }}个 -->
              </el-col>
          </el-row>
      </div>
        <div class="main">
            <el-row :gutter="30">
                <el-col :span="12">
                    <div class="lx-flex-row" style="margin-bottom:20px;">
                        <el-input v-model="searchForm.goodsName" placeholder="货品名称"></el-input>
                        <el-input style="margin:0 20px;" class="ml15" v-model="searchForm.orderId" placeholder="订单编号"></el-input>
                        <el-button class="lx-flex-shrink-0 ml15" type="primary" @click.native="doSearch">搜索</el-button>
                        <el-button class="lx-flex-shrink-0 ml15" type="primary" @click.native="doReset">重置</el-button>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :span="12">
                    <el-table   ref="multipleTable" row-key="id" class="mt20 mb10" @selection-change="handleSelectionChange" :data="dataList" border>
                       <el-table-column
      type="selection"
      align="center"
      reserve-selection
      width="55">
    </el-table-column>
                        <el-table-column prop="orderId" label="订单编号" header-align="center" align="center" width="80">
                        </el-table-column>
                        <el-table-column label="商品名称" header-align="center" align="center">
                          <template slot-scope="scope">
                            {{scope.row.goodsName | empty}}
                          </template>
                        </el-table-column>
                      <el-table-column prop="colour" label="颜色" header-align="center" align="center" width="80">
                      </el-table-column>
                      <el-table-column prop="goodsSize" label="尺寸" header-align="center" align="center" width="80">
                      </el-table-column>
                      <el-table-column  label="图片" header-align="center" align="center">
                        <template v-slot="scope">
                          <img @click="imgclick(scope.row.pictureUrl,true)" v-if="scope.row.pictureUrl&&scope.row.pictureUrl.length>0" :src="scope.row.pictureUrl" alt="" class="list-image">
                          <img v-else src="@/assets/images/default.png" alt="" class="list-image">
                        </template>
                      </el-table-column>
                        <el-table-column prop="createTime" label="下单日" header-align="center" align="center" >
                            <template v-slot="scope">
              {{ scope.row.createTime | dateFormatToDay }}
            </template>
                        </el-table-column>
                        <el-table-column prop="receiveTime" label="到库日" header-align="center" align="center" >
                            <template v-slot="scope">
              {{ scope.row.receiveTime | dateFormatToDay }}
            </template>
                        </el-table-column>
                        <el-table-column label="订单状态" header-align="center" align="center" width="80">
                            <template slot-scope="scope">
                                <el-tag  type="success" size="mini" effect="dark">
                                    {{scope.row.orderStatus | orderStatusFilter}}
                                </el-tag>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        :current-page="searchForm.pageNum"
                        :page-sizes="[5, 10, 20, 50, 100]"
                        :page-size="searchForm.pageSize"
                        :total="total"
                        layout="total, sizes, prev, pager, next, jumper"
                        @size-change="pageSizeChangeHandle"
                        @current-change="pageCurrentChangeHandle">
                    </el-pagination>
                </el-col>
                <el-col :span="12">
                     <el-table class="mt20 mb10" :data="curSelectList" max-height="600px" empty-text="暂无选择" border>
                        <el-table-column header-align="center" width="50" align="center">
                            <template slot-scope="scope">
                                <i class="el-icon-circle-close fz16 lx-pointer" @click.stop="handleCurrentChange(scope.row)"></i>
                            </template>
                        </el-table-column>
                        <el-table-column prop="orderId" label="订单编号" header-align="center" align="center" width="80">
                        </el-table-column>
                        <el-table-column label="商品名称" header-align="center" align="center">
                          <template slot-scope="scope">
                            {{scope.row.goodsName | empty}}
                          </template>
                        </el-table-column>
                       <el-table-column prop="colour" label="颜色" header-align="center" align="center" width="80">
                       </el-table-column>
                       <el-table-column prop="goodsSize" label="尺寸" header-align="center" align="center" width="80">
                       </el-table-column>
                       <el-table-column label="图片" header-align="center" align="center">
                         <template v-slot="scope" >
                           <img @click="imgclick(scope.row.pictureUrl,true)" v-if="scope.row.pictureUrl&&scope.row.pictureUrl.length>0" :src="scope.row.pictureUrl" alt="" class="list-image">
                           <img v-else src="@/assets/images/default.png" alt="" class="list-image">
                         </template>
                       </el-table-column>
                        <el-table-column prop="createTime" label="下单日" header-align="center" align="center" width="80">
                          <template v-slot="scope">
              {{ scope.row.createTime | dateFormatToDay }}
            </template>
                        </el-table-column>
                        <el-table-column prop="receiveTime" label="到库日" header-align="center" align="center" width="80">
                          <template v-slot="scope">
              {{ scope.row.receiveTime | dateFormatToDay }}
            </template>
                        </el-table-column>
                          <el-table-column prop="goodsPrice" label="已购买" header-align="center" align="center" width="80">
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </div>
        <el-dialog
  :visible.sync="dialogVisible"
  width="600px"
  :modal='false'
  :before-close="closAlready"
  :modalAppendToBody='false'
  >
  <span>请选择已有同捆</span>
   <el-table
    ref="singleTable"
    :data="splitList"
    highlight-current-row
    @current-change="handleCurrentChangeOnly"
    style="width: 100%">
    <el-table-column
      property="tongkunNo"
      label="同捆编号"
      width="120">
    </el-table-column>
    <el-table-column
      property="createTime"
      label="同捆创建时间"
      width="120">
        <template v-slot="scope">
              {{ scope.row.createTime | dateFormatToDay }}
            </template>
    </el-table-column>
    <el-table-column
      property="receiverName"
      label="收件人">
    </el-table-column>
     <el-table-column
      property="status"
      label="同捆状态">
        <template v-slot="scope">
              {{ tongkunStatusShow(scope.row.status) }}
            </template>
    </el-table-column>
  </el-table>
  <span slot="footer" class="dialog-footer">
    <el-button @click="closAlready">取 消</el-button>
    <el-button type="primary" @click="handleSaveNew">确 定</el-button>
  </span>
</el-dialog>
      <div slot="custome-footer" class="lx-flex-row-center">
        <el-button
          @click.native="handleClose"
          >取消</el-button
        >
         <el-button
          type="primary"
          class="mr30"
          @click.native="handleAlready"
          >拆分到已有同捆</el-button
        >
         <el-button
          type="primary"
          class="mr30"
          @click.native="handleNew"
          >拆分到新的同捆</el-button
        >
      </div>
       <el-dialog
           :modal="false"
           title=""
           :visible.sync="imgVisible"
           width="30%"
           show-close
           center>
         <img width="100%" height="auto" :src="imgurl" alt="" class="list-image">
         <!--    <img :src="this.$store.state.imgurl" alt="">-->
       </el-dialog>
    </lx-dialog>
</template>
<script>
import LxDialog from '@/components/LxDialog'

export default {
  name: 'LxSelectGoods',
  components: { LxDialog },
  props: {
    title: {
      type: String,
      default: ''
    },
    selectList: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    },
    id:{
      type: Number,
      default: -1
    }
  },
  data () {
    return {
      dataList: [],
      curSelectList: [],
      total: 0,
      searchForm:{
          pageNum: 1,
          goodsName:'',
          orderId:'',
          pageSize: 10,
      },
      imgVisible: false,
      imgurl: '',
      timeout: null,
      dialogVisible:false,
        currentRow: null,
        splitList:[]
    }
  },
   computed: {
    isVisiable: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    isVisiable (val) {
      if (val) {
        this.getDataList()
      }else{
         this.curSelectList = []
        this.$refs.multipleTable.clearSelection();
      }
    },
    // curSelectList: {
    //   handler (newList) {
    //     if (this.isVisiable) this.initList(this.dataList, newList)
    //   },
    //   immediate: true,
    //   deep: true
    // }
  },
  methods: {
    imgclick(url,flag){
      this.imgVisible=flag
      this.imgurl=url
    },
    doSearch () {
      this.searchForm.page = 1
      this.getDataList(this.curSelectList)
    },
    closAlready(){
      this.currentRow = null
      this.dialogVisible = false
    },
    handleSaveNew(){
      if(this.currentRow){
          let params = {
          tongkunOrderList:this.curSelectList,
          id:this.id,
          targetTongkunId:this.currentRow.id
        }
        this.$http.post('/tongkun/splitTongkun', params).then(res => {
          if(res.data.code==200){
             this.$message.success('操作成功')
             this.$emit('getrecordList')
             this.isVisiable = false
             this.currentRow = null
             this.dialogVisible = false
          }else{
               this.$message.error(res.data.message)
          }
      })
      }else{
        this.$message.error('请选择已有同捆')
      }
    },
    //拆分到已有同捆
    handleAlready(){
      if(this.curSelectList.length==0){
        this.$message.error('请先选择')
      }else{
        this.dialogVisible = true
      this.getSplitList()
      }
    },
    handleNew(){
      if(this.curSelectList.length==0){
        this.$message.error('请先选择商品')
      }else{
        let params = {
          tongkunOrderList:this.curSelectList,
          id:this.id
        }
        this.$http.post('/tongkun/splitTongkun', params).then(res => {
          if(res.data.code==200){
             this.$message.success('操作成功')
             this.isVisiable = false
             this.currentRow = null
             this.$emit('getrecordList')
          }else{
               this.$message.error(res.data.message)
          }
      })
      }
    },
     tongkunStatusShow(status) {
      switch (status) {
        case '1':
          return '发送中'
        case '2':
          return '申请发货'
        case '3':
          return '已到齐'
        case '4':
          return '已打包'
        case '5':
          return '等待到库'
        case '6':
          return '待支付'
        case '7':
          return '已发送'
        case '9':
          return '已取消'
      }
    },
    hasAddressCheck(status){
      switch (status) {
         case '1':
          return '发送中'
        case '2':
          return '申请发货'
        case '3':
          return '已到齐'
        case '4':
          return '已打包'
        case '5':
          return '等待到库'
        case '6':
          return '待支付'
        case '7':
          return '已发送'
        case '9':
          return '已取消'
      }
    },
     setCurrent(row) {
        this.$refs.singleTable.setCurrentRow(row);
      },
      handleCurrentChangeOnly(val) {
        this.currentRow = val;
      },
    // 选择
    handleSelectionChange (list) {
      this.curSelectList = list
    },
    // 删除某一项
   handleCurrentChange(row) {
        this.dataList.forEach(item=>{
          if(item.id==row.id){
             this.$refs.multipleTable.toggleRowSelection(item,false);
          }
        })
      },
    getDataList () {
      this.searchForm.id = this.id
      const params = this.searchForm
      this.$http.get('/tongkun/pageForOrderList', { params }).then(res => {
        let data = res.data.data
        console.log(data)
        this.total = data.total
        this.dataList = data.list
      })
    },

    getSplitList () {
      const params = {
        id:this.id
      }
      this.$http.get('/tongkun/getSplitOrderList', { params }).then(res => {
        this.splitList = res.data.data
      })
    },
    // 初始化列表样式
    initList () {

    },
    // 取消
    handleClose () {
      this.isVisiable = false
    },
    // 确定
    handleSave () {
      this.$emit('confirm', this.curSelectList)
    },
    // 重置
    doReset () {
      console.log(this.searchForm)
      this.searchForm.orderId = ''
      this.searchForm.goodsName = ''
      this.searchForm.pageNum = 1
    },

    // 分页, 每页条数
    pageSizeChangeHandle (val) {
      this.searchForm.pageNum = 1
      this.searchForm.pageSize = val
      this.$nextTick(() => {
        this.getDataList()
      })
    },
    // 分页, 当前页
    pageCurrentChangeHandle (val) {
      this.searchForm.pageNum = val
      this.$nextTick(() => {
        this.getDataList()
      })
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-table .el-table__body tr.el-table__row.current-row td, .el-table__body tr.current-row>td, .el-table__body tr.hover-row.current-row>td, .el-table__body tr.hover-row.el-table__row.current-row>td, .el-table__body tr.hover-row.el-table__row>td, .el-table__body tr.hover-row>td

{

background-color:#c1d3e7;

}

</style>
